import './qr-scanner.scss';

// import { Html5QrcodeScanner } from 'html5-qrcode';
import {CameraDevice, Html5Qrcode, Html5QrcodeCameraScanConfig } from 'html5-qrcode';

import Component from '../component/component';

// interface IQrConfig {
//     fps: number;
//     qrbox: {
//         width: number;
//         height: number;
//     };
//     aspectRatio: number;
// }

/* eslint-disable */
enum Html5QrcodeSupportedFormats {
    QR_CODE = 0,
    AZTEC,
    CODABAR,
    CODE_39,
    CODE_93,
    CODE_128,
    DATA_MATRIX,
    MAXICODE,
    ITF,
    EAN_13,
    EAN_8,
    PDF_417,
    RSS_14,
    RSS_EXPANDED,
    UPC_A,
    UPC_E,
    UPC_EAN_EXTENSION,
}
/* eslint-enable */

class QrcodeResultFormat {
    public readonly format: Html5QrcodeSupportedFormats;
    public readonly formatName: string;
}

interface IQrcodeResult {
    /** Decoded text. */
    text: string;

    /** Format that was successfully scanned. */
    format?: QrcodeResultFormat,
}

interface IHtml5QrcodeResult {
    decodedText: string;
    result: IQrcodeResult;
}

export default class QrScanner extends Component {
    static initSelector: string = '.js-qr-scanner';

    html5QrCode: Html5Qrcode;

    constructor(element: HTMLElement) {
        super(element);

        this.init();
    }

    init(): void {
        const scannerId: string = this.element.querySelector('.qr-scanner__scanner').getAttribute('id');

        this.html5QrCode = new Html5Qrcode(scannerId);
        const config: Html5QrcodeCameraScanConfig = {
            fps: 10,
            qrbox: { width: 180, height: 180 },
            aspectRatio: 1,
        };

        Html5Qrcode.getCameras().then((devices: CameraDevice[]) => {
            const idOrConfig:string | MediaTrackConstraints = { facingMode: 'environment' };

            // facingMode: 'environment' will select fisheye camera if available
            // acording to this info: https://www.reddit.com/r/javascript/comments/8eg8w5/choosing_cameras_in_javascript_with_the/
            // "normal" environment camera is usually the last camera in the list

            if (devices && devices.length > 2) { // if there are more than 2 cameras, then expect to have more than 1 environment camera
                // idOrConfig = devices[devices.length - 1].id;
            }

            this.html5QrCode.start(
                idOrConfig,
                config, this.qrCodeSuccessCallback.bind(this),
                this.qrCodeErrorCallback.bind(this))
                .catch(() => {
                    this.element.classList.add('not-allowed');
                });

            document.addEventListener('stopScanner', this.stopScanner.bind(this));
        }).catch(() => {
            this.element.classList.add('not-allowed');
        });


    }


    // eslint-disable-next-line
    qrCodeSuccessCallback(decodedText: string, decodedResult: IHtml5QrcodeResult): void {
        const customEvent: CustomEvent = new CustomEvent('scanSuccess', {
            detail: {
                decodedText,
                decodedResult,
            },
        });

        this.element.dispatchEvent(customEvent);
    }

    // eslint-disable-next-line
    qrCodeErrorCallback(decodedText: string, decodedResult: any): void {
        /* handle error */
        // Note that this is not really an error,
        // rather just the QR code not currently being in camera viewport
    }

    stopScanner(): void {
        try {
            this.html5QrCode.stop();
        } catch (e) {
            // catch errors when multiple scanners are on the page (but only 1 active)
        }
    }
}
